import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import StyledSmartLink from '../../../../ShareIncident/StyledSmartLink';
import {
  AccordionSectionDesc,
  AccordionSectionTitle,
  AccordionSectionSubTitle,
} from '../../../CustomAccordion.styles';

const HazCarHeader = ({ data }) => {
  const { equipment_id, railcarSequence, Container } = data;
  return (
    <Box flow={5}>
      <AccordionSectionTitle>
        CAR {railcarSequence} - {equipment_id}
      </AccordionSectionTitle>
      {Container && Container.length > 0 ? (
        <Box flow={16}>
          {Container.map((container, idx) => (
            <HazSubHeader data={container} key={idx} />
          ))}
        </Box>
      ) : (
        <HazSubHeader data={data} />
      )}
    </Box>
  );
};

const HazSubHeader = ({ data }) => {
  const { HazmatSource } = data;
  return (
    <Box flow={4}>
      {data?.container_id && (
        <AccordionSectionSubTitle>
          Container {data.container_id}
        </AccordionSectionSubTitle>
      )}
      {HazmatSource && (
        <Box flow={4}>
          <AccordionSectionDesc>
            {HazmatSource.proper_shipping_name}
          </AccordionSectionDesc>
          <AccordionSectionDesc>
            <StyledSmartLink to={HazmatSource.erg_url}>
              ERG Guide: {HazmatSource.erg_guide_number}
            </StyledSmartLink>
          </AccordionSectionDesc>
        </Box>
      )}
    </Box>
  );
};

export default HazCarHeader;
